import React from 'react';
import PropTypes from 'prop-types';

import { InputGroup, Input, InputGroupAddon, InputGroupText } from 'reactstrap';

import { Field, ErrorMessage } from "formik";
import { CurrentTheme } from "common";
import MagstimInputGroup from './MagstimInputGroup'

// const AUTO_COMPLETE_OFF = 'off';

class MagstimInputGroupCheckBoxWithCheckBox extends MagstimInputGroup {

    onCheckboxChange = () => {
        const newCheckState = !this.state.checked;
        this.setState({checked:newCheckState, disabled:!newCheckState})

        if(this.props.onSetEnabled !== undefined){
            this.props.onSetEnabled(this.props.name, newCheckState, this.props.validateForm);
        }
    }

    render() {

        const placeholder = this.props.title.replace('*', '')

        var titleClassName = "input-group-highlight"

        if(this.state.disabled === true){
            titleClassName = "input-group-disabled"
        }

        return(
            <>
            <InputGroupAddon addonType="prepend" className="d-md-none d-lg-none prepend-mobile">
                <InputGroupText className={titleClassName}>{this.props.title}</InputGroupText>
            </InputGroupAddon>
            <InputGroup size={CurrentTheme().ControlSize}>
                
                <InputGroupAddon addonType="prepend"  className="d-none d-md-block">
                    <InputGroupText className={titleClassName}>{this.props.title}</InputGroupText>
                </InputGroupAddon>
                <InputGroupAddon addonType="append" className="magstim-checkbox-container mr-3">
                    <Input type="checkbox" className="magstim-checkbox" checked={this.state.checked} onChange={this.onCheckboxChange}/>
                </InputGroupAddon> 
                <Input type="checkbox"
                    className={`magstim-checkbox form-control ${ this.props.touched && this.props.errors ? "is-invalid" : "" }`}
                    disabled={this.state.disabled} 
                    onFocus={this.onFocus} 
                    name={this.props.name} 
                    placeholder={placeholder} 
                    tag={Field}
                    />
                
             

                <ErrorMessage component="div" name={this.props.name} className="invalid-feedback" />
            </InputGroup>
        </>
        );
    }
}

MagstimInputGroupCheckBoxWithCheckBox.propTypes = {
    title: PropTypes.string,
    name:PropTypes.string,
    touched:PropTypes.bool,
    errors:PropTypes.string,
    disabled:PropTypes.bool,
    checked:PropTypes.bool,
    onSetEnabled:PropTypes.func,
    validateForm:PropTypes.func,
};

MagstimInputGroupCheckBoxWithCheckBox.defaultProps = {
    title: "",
    name:"",
    touched:false,
    errors:undefined,
    disabled:false,
    checked:undefined,
    onSetEnabled:undefined,
    validateForm:undefined
};

export default MagstimInputGroupCheckBoxWithCheckBox